import classNames from 'classnames';
import dayjs from 'dayjs';
import { CSSProperties, useCallback, useMemo } from 'react';
import { Icon } from 'tdesign-icons-react';
import { Button, Collapse, Select } from 'tdesign-react';

import { EditorDel } from '@/components/icon';
import { OperandType, OperatorsType } from '@/interface/numberSysytem';
import { validateOpGroupCalculate } from '@/pages/mission/info/validate';

import { ACTIVATION_COND, NUM_CHANGE } from '..';
import ItemCard, { ItemCardData } from './card';
import styles from './index.module.less';

const { Panel } = Collapse;

// 卡片数据类型定义
export interface CardData {
  id: string;
  logicalOp: OperatorsType;
  opGroup: ItemCardData[]
}

interface IProps {
  fileName: string;
  label: string;
  disabled: boolean;
  onChange: (data: CardData[]) => void;
  value: CardData[];
  leftStyle?: CSSProperties;
  buttonStyle?: CSSProperties;
}
// 新增子条件
const ItemCardContainer: React.FC<IProps> = (props) => {
  const { fileName, label, disabled, value, leftStyle, buttonStyle, onChange } = props;
  // 卡片数据状态

  const cards = useMemo(() => value, [value]);

  // 新增卡片
  const handleAddCard = () => {
    const logicalOp = cards?.length == 0 ? OperatorsType.DEFAULT : OperatorsType.AND;
    const newCard: CardData = {
      id: dayjs().valueOf() + cards?.length.toString(),
      logicalOp, // 且
      opGroup: [{
        id: dayjs().valueOf() + cards?.length.toString(),
        op: OperatorsType.DEFAULT,
        operand: {
          operandType: OperandType.VARIABLE,
          variableNumId: '',
          constantVal: 0,
        },
      }],
    };
    const result = [...cards, newCard];
    onChange(result);
  };

  // 删除卡片
  const handleDeleteCard = (id: string, e: React.MouseEvent) => {
    e.stopPropagation();
    const result = cards.filter(card => card.id !== id);
    onChange(result);
  };

  const panelHeader = useCallback((i: number) => (
    <div className={styles.panelHeader}>
      <div>{`子条件${cards?.length > 1 ? i + 1 : ''}`}</div>
      <Button
        className={classNames(styles.delete, {
          'nova-disabled-opacity': disabled,
        })}
        disabled={disabled}
        theme="default"
        onClick={(e) => {
          handleDeleteCard(cards[i].id, e);
        }}
      >
        <EditorDel />
      </Button>
    </div>
  ), [disabled, cards]);

  const handleChange = (id: string, val: ItemCardData[]) => {
    const result = cards.map((card) => {
      if (card.id === id) {
        return {
          ...card,
          opGroup: val,
        };
      }
      return card;
    });
    onChange(result);
  };

  const handleChangeLogicalOp = (id: string, val: OperatorsType) => {
    const result = cards.map((card) => {
      if (card.id === id) {
        return {
          ...card,
          logicalOp: val,
        };
      }
      return card;
    });
    onChange(result);
  };

  const logicalOpOptions = useMemo(() => {
    if (fileName === NUM_CHANGE) {
      return [{ label: '且', value: OperatorsType.AND }];
    }
    return [
      { label: '且', value: OperatorsType.AND },
      { label: '或', value: OperatorsType.OR },
    ];
  }, [fileName]);

  return (
    <div className={styles.container}>
      <div className={styles.left} style={leftStyle}>
        <span className={styles.label}>{label}</span>
      </div>

      <div className={styles.right}>
        <div className={styles.toolbar}>
          <Button
            theme="default"
            size='medium'
            disabled={disabled}
            style={{ width: 100, height: 32, ...buttonStyle }}
            onClick={handleAddCard}
            icon={<Icon name="add" />}
          >
            新增子条件
          </Button>
        </div>
        <div className={styles.cards}>
          {
            cards?.map((e, i) => {
              const errorTips = fileName === ACTIVATION_COND
                ? validateOpGroupCalculate(e?.opGroup)?.message : '';
              return (
                <div key={i + e?.id} className={styles.card}>
                  {
                    i == 0 ? null
                      : <Select
                        className={styles.op}
                        value={e?.logicalOp}
                        style={{ width: '98px' }}
                        disabled={disabled}
                        placeholder='判断规则'
                        onChange={(val) => {
                          handleChangeLogicalOp(e.id, val as OperatorsType);
                        }}
                        options={logicalOpOptions}
                      />
                  }
                  <div className={styles.collapse}>
                    <Collapse
                      defaultValue={['default']}
                      expandIconPlacement={'right'}
                    >
                      <Panel header={panelHeader(i)} value="default">
                        <ItemCard
                          disabled={disabled}
                          onChange={val => handleChange(e?.id, val)}
                          value={e}
                          fileName={fileName}
                        />
                        {
                          errorTips && !disabled ? <div className={styles.errorMsg}>{errorTips}</div> : null
                        }
                      </Panel>

                    </Collapse>
                  </div>
                </div>
              );
            })
          }
        </div>
      </div>
    </div>
  );
};

export default ItemCardContainer;
